import {isKioskApp} from "@/shared/helpers/webapp";

function installInMemoryStorage(name) {
	delete window[name];
	window[name] = {};
	window[name].items = {};
	window[name].getItem = key => {
		return window[name].items[key] || null;
	};
	window[name].removeItem = key => {
		delete window[name].items[key];
	};
	window[name].setItem = (key, value) => {
		window[name].items[key] = value;
	};
	window[name].clear = () => {
		window[name].items = {};
	};
}

function isStorageSupported(name) {
	try {
		if (!(name in window) || window[name] === null) {
			return false;
		}
		const testKey = 'storageTest';
		window[name].setItem(testKey, 'foo');
		window[name].removeItem(testKey);
		return true;
	} catch (e) {
		return false;
	}
}

export function checkLocalStorageSupport() {
	if (!isStorageSupported('localStorage')) {
		installInMemoryStorage('localStorage');
	}
	if (!isStorageSupported('sessionStorage')) {
		installInMemoryStorage('sessionStorage');
	}
}

export function neutralizeStorageForKiosk() {
	if (!isKioskApp()) {
		return;
	}
	for (const name of ['localStorage', 'sessionStorage']) {
		try {
			window[name]?.clear?.();
		} catch (e) {
			// real storage may throw in restricted WebView contexts; ignored — polyfill below masks it
		}
		installInMemoryStorage(name);
	}
}
